module.exports = "<app-widgets-summary object=$ctrl.archive type=archive></app-widgets-summary> <app-widgets-review-info-edit object=$ctrl.archive on-change=$ctrl.setDirty()></app-widgets-review-info-edit> <app-widgets-savecancel on-cancel=$ctrl.cancel() on-save=$ctrl.save() save-enabled=\"$ctrl.dirty && $ctrl.valid\" update-permission=true> </app-widgets-savecancel> <br> <ui-view></ui-view> <br> <app-widgets-savecancel on-cancel=$ctrl.cancel() on-save=$ctrl.save() save-enabled=\"$ctrl.dirty && $ctrl.valid\" update-permission=true> </app-widgets-savecancel> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/edit/template/partial.html
// module id = 397
// module chunks = 0